/* blocks */
import PageHero from './components/PageHero/PageHero'
import DecodingAISearch from './components/DecodingAISearch/DecodingAISearch'
import AISearch from './components/AISearch/AISearch'
import PeopleSpeaking from './components/PeopleSpeaking/PeopleSpeaking'
import Highlights from './components/Highlights/Highlights'
import Agenda from './components/Agenda/Agenda'
import GearingUp from './components/GearingUp/GearingUp'
import InviteOnly from './components/InviteOnly/InviteOnly'
import Footer from './components/Footer/Footer'

/* utils */
import { Index25PageAttributes } from '@/utils/queries/index-25/index_25'

interface Props {
  data: Index25PageAttributes
}

function Index25PageTemplate({ data }: Props) {
  return (
    <>
      {data.heroDescription ? (
        <PageHero
          title={data.heroDescription}
          image={data.heroImage.data.attributes}
          heroBgVideo={data.heroBgVideo.data.attributes}
        />
      ) : null}

      {data.decodingVideo ? (
        <DecodingAISearch
          decodingDescription={data.decodingDescription}
          decodingVideoLink={data.decodingVideo}
          eventDate={data.eventDate}
          eventType={data.eventType}
        />
      ) : null}

      {data.aiSearchList.length > 0 ? (
        <AISearch
          title={data.aiSearchTitle}
          description={data.aiSearchDescription}
          list={data.aiSearchList.map(item => ({
            id: item.id,
            title: item.title ?? '',
            description: item.description ?? ''
          }))}
        />
      ) : null}

      {data.peopleSpeakingList.length > 0 ? (
        <PeopleSpeaking
          title={data.peopleSpeakingTitle}
          list={data.peopleSpeakingList}
        />
      ) : null}

      {data.highlightsList.length > 0 ? (
        <Highlights title={data.highlightsTitle} list={data.highlightsList} />
      ) : null}

      {data.agendaList.length > 0 ? (
        <Agenda
          title={data.agendaTitle}
          description={data.agendaDescription}
          list={data.agendaList}
        />
      ) : null}

      {data.gearingUpList.length > 0 ? (
        <GearingUp title={data.gearingUpTitle} list={data.gearingUpList} />
      ) : null}

      <InviteOnly title={data.formTitle} description={data.formDescription} />

      {data.footerCta.title ? (
        <Footer
          title={data.footerCta.title}
          description={data.footerCta.description ?? ''}
          primaryCta={data.footerCta.primaryCta}
        />
      ) : null}
    </>
  )
}

export default Index25PageTemplate
